/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import ua from '@tencent/docs-user-agent';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';
import { getTencentMeetingSDK } from '@utils/tencent-meeting';
import { getUrlParameter } from '@src/slide/infrastructure/module/independent/url/param-operation';

declare global {
    interface Window {
        WeworkEventApi: any;
        WeworkJsApi: any;
        qmailBridge: any;
        // eslint-disable-next-line camelcase
        WeDoc_WindowId: string;
        tdocs?: any;
    }
}

// 企微内分享转发所需参数
interface IForwardParams {
    menuType: number;
    from: string;
    positionX?: number;
    positionY?: number;
    positionType?: string;
    convId?: string;
}

const DocType  = {
    doc: 0,
    sheet: 1,
    form: 2,
    slide: 3,
    mind: 4,
    flowchart: 5,
};

const CARD_WIDTH = 324;
const GAP_WIDTH = 5; // 转发微信会话框距会议窗口右边距
const GAP_HEIGHT = 56; // 转发微信会话框距会议窗口上边距

// 文档融合企业微信提供新的Bridge
export class MyWeworkJsApi {
    private positionX = 0;
    private positionY = 0;

    public async searchContacts() {
        return null;
    }
    public showDiscussWindow(params) {
        tdocsBridge.tdocs?.showDiscussWindow?.({
            positionType: 'rightBottom',
            ...params,
        });
    }
    public hideOneDiscussWindow(docId = '') {
        tdocsBridge.tdocs?.hideOneDiscussWindow?.({ docId });
    }

    public destroyDiscussWindow(params) {
        tdocsBridge.tdocs?.destroyDiscussWindow?.(params);
    }

    public notifyPush({ docId, conversationList, isNeedPush = true }) {
        tdocsBridge.tdocs?.notifyPush?.({ isNeedPush, docId, conversationList  });
    }

    public getFocusWindowHandle() {
        return '';
    }
    public wwappDocOnOpenMenu(params: IForwardParams): void {
        const { padId: docId, creatorId: creatorVid, title, padType } = window.clientVars as any;
        const forwardParams = {
            docId,
            title,
            creatorVid,
            docType: DocType[padType] || 0,
            platformType: 3, // 1.邮箱自研， 2.SDK文档 3.混合文档， 给企业微信客户端用的
            shareCode: getUrlParameter('scode') || '',
            ...params,
        };
        switch (params.menuType) {
            case 2:
                // 转发到企业微信
                this.forwardToWwapp(forwardParams);
                break;
            default:
                break;
        }
    }
    public urlChange(callback: (url: string) => void) {
        window.qmailBridge.urlChange?.(callback);
    }

    /**
     * 计算融合会议内转发会话框所需展示的位置
     * 因为位置信息传给企微但是企微不知道会议webview的位置，所以需要根据点击事件时的屏幕定位
     * @param event
     */
    public handleTopMenuPosition = (event: MouseEvent): void => {
        event.stopPropagation();
        event.preventDefault();
        this.positionX = event.screenX - event.clientX + window.innerWidth - CARD_WIDTH - GAP_WIDTH;
        this.positionY = event.screenY - event.clientY + GAP_HEIGHT;
    };

    // 转发到企微会话
    private async forwardToWwapp(data) {
        // 融合会议内转发
        if (ua.isTencentMeeting) {
            // FIXME: wemeet-sdk 版本未升级
            const { remixApp } = await getTencentMeetingSDK() as any;
            remixApp.execRemixAppCmd({
                cmd: 'wwapp.meetdoc.forwardDoc',
                data: {
                    ...data,
                    positionX: this.positionX,
                    positionY: this.positionY,
                    positionType: 'leftTop',
                    hideDiscussWindow: 1,
                },
            });
            return;
        }
        // 企微内转发
        tdocsBridge.tdocs.quoteToDiscuss(data);
    }
}

// 判断渠道替换不同的环境
export const WeworkJsApi = new MyWeworkJsApi();
